import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { overrideOrganizationHeader } from '@cast/api-client';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const RBAC_ORGANIZATION_USER_GROUPS_QUERY_KEY =
  'rbac-organization-user-groups';
const getRbacUserGroupsKey = (params: { organizationId: string }) =>
  [RBAC_ORGANIZATION_USER_GROUPS_QUERY_KEY, params.organizationId] as const;

const getRbacUserGroupsQueryOptions = ({
  organizationId,
  enabled = true,
}: {
  organizationId: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getRbacUserGroupsKey({ organizationId }),
    queryFn: async () => {
      const { data } = await apiClient.rbac.listGroups(
        {
          organizationId,
          pageLimit: '9999',
        },
        {
          headers: overrideOrganizationHeader(organizationId),
        }
      );
      return data.groups ?? [];
    },
    enabled: enabled && !!organizationId,
  });

type UseRbacUserGroupsQueryArgs = {
  enabled?: boolean;
  organizationId?: string;
};

export const useRbacUserGroupsQuery = ({
  enabled = true,
  organizationId,
}: UseRbacUserGroupsQueryArgs = {}) => {
  const { currentOrganization: organization } = useOrganizations();
  const resolvedOrganizationId = organizationId ?? organization?.id;

  const query = useQuery(
    getRbacUserGroupsQueryOptions({
      organizationId: resolvedOrganizationId!,
      enabled,
    })
  );

  return { groups: query.data, ...query };
};
